/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetManyBaseAodRulesControllerAodRuleQueryResponse, GetManyBaseAodRulesControllerAodRuleQueryParams } from "../models/GetManyBaseAodRulesControllerAodRule";

export function getGetManyBaseAodRulesControllerAodRuleUrl() {
  const res = { method: 'GET', url: `/aod-rules` as const }
  return res
}

/**
 * @summary Retrieve multiple AodRules
 * {@link /aod-rules}
 */
export async function getManyBaseAodRulesControllerAodRule(params?: GetManyBaseAodRulesControllerAodRuleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetManyBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetManyBaseAodRulesControllerAodRuleUrl().url.toString(), params, ... requestConfig })
  return res.data
}